import { Box } from "@mui/material";
import { useState } from "react";
import { Navigate } from "react-router-dom";
import PurchaseManagementMenu from "../features/purchase/purchase-menu";
import RequestIndent from "../features/purchase/request-indent/Request-Indent";
import ApproveRequestIndent from "../features/purchase/request-indent/ApproveRequestIndent";
import PurchaseIndent from "../features/purchase/purchase-indent/PurchaseIndent";

import Vendor from "../features/purchase/vendor/Vendor";

import PurchaseOrder from "../features/purchase/order/PurchaseOrder";
import PurchaseReceives from "../features/purchase/receives/PurchaseReceives";

// call page
// import BundleLabel from "../productionmanagement/Bundle-punching.jsx";
// import ReamLabel from "../productionmanagement/Ream-punching.jsx";
// import InventoryLog from "../productionmanagement/inventorylog.jsx";
// import ViewQRAndBarCodeSettings from "../productionmanagement/QR-code-settings.jsx";
// import ViewProductionDocumentSequence from "../productionmanagement/Production-document-sequence.jsx";
// import PurchaseManagementMenu from "./Purchase-menu.jsx";
// import VendorIndex from "./Vendor.jsx";
// import PurchaseOrder from "./Purchase-order.jsx";
// 
import PurchaseBill from "../features/purchase/bill/PurchaseBill";
import PurchaseReturns from "../features/purchase/return/PurchaseReturn";
// import StoreMaster from "./Store.jsx";
// import MaterialMaster from "./Material.jsx";
// import RequestIndent from "./Request-Indent.jsx";
// import ApproveRequestIndent from "./Approve-request-indent.jsx";
// import IssueIndent from "./Issue-Indent.jsx";
import ReturnIndent from "../features/purchase/return-indent/ReturnIndent";
// import AddStoreLedger from "./Store_ledger.jsx";
// import MaterialStockUpload from "./MaterialStockUpload.jsx";

// import VendorEnquiry from "./Vendor-Enquiry.jsx";
// import VendorResponse from "./VendorResponse.jsx";
import PurchaseInspections from "../features/purchase/inspection/PurchaseInspection";
import ApproveInspections from "../features/purchase/inspection-approval/ApprovalInspection";
import PurchaseInspectionReturn from "../features/purchase/inspection-return/PurchaseInspectionReturn";


import VendorEnquiry from "../features/purchase/vendor-enquiry/VendorEnquiry";
import VendorResponse from "../features/purchase/vendor-quotation/VendorResponse";
import QuotationList from "../features/purchase/vendor-quotation-comparision/QuotationList";



const PurchaseManagement = () => {


    const [activePage, setActivePage] = useState('ViewMainPage');

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }

    return (


        <Box position="relative">


            {activePage === "ViewMainPage" && (<PurchaseManagementMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}

            {/* 1.Paper  Machine Production Entry */}
            {activePage === "ViewVendorPage" && (
                <Vendor handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* Winder Reel Production Entry */}
            {activePage === "ViewPurchaseOrder" && (
                <PurchaseOrder handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* view Reel Weightment */}
            {activePage === "ViewPurchaseReceives" && (
                <PurchaseReceives handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* Cutter Sheet Convertion Entry */}
            {activePage === "ViewPurchaseBills" && (
                <PurchaseBill handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewPurchaseReturns" && (
                <PurchaseReturns handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* {activePage === "ViewStore" && (
                <StoreMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewMaterial" && (
                <MaterialMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {activePage === "RequestIndent" && (
                <RequestIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={0} />
            )}
            {activePage === "ApproveRequestIndent" && (
                <ApproveRequestIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={0} />
            )}
            {/* {activePage === "IssueIndent" && (
                <IssueIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}
            {activePage === "ReturnIndent" && (
                <ReturnIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {/* {activePage === "StoreLedger" && (
                <AddStoreLedger handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewReamWeightment" && (
                <ReamLabel handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewBundleWeightment" && (
                <BundleLabel handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewInventoryLog" && (
                <InventoryLog handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewDocumentSequence" && (
                <ViewProductionDocumentSequence handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewQRCodeSettings" && (
                <ViewQRAndBarCodeSettings handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}
            {/* {activePage === "ViewMaterialStock" && (
                <MaterialStockUpload handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}
            {activePage === "PurchaseIndent" && (
                <PurchaseIndent handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "VendorEnquiry" && (
                <VendorEnquiry handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {/* {activePage === "VendorQuotation" && (
                <VendorResponse handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* {activePage === "ViewQCcheck" && (
                <QualityInspectionForm handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {/* PurchaseInspections */}
            {activePage === "ViewQCcheck" && (
                <PurchaseInspections handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={0} />
            )}

            {activePage === "ViewReceivesApproval" && (
                <ApproveInspections handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={0} />
            )}

            {activePage === "ViewPurchaseInspectionReturns" && (
                <PurchaseInspectionReturn handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={0} />
            )}

            {activePage === "VendorQuotation" && (
                <VendorResponse handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={0} />
            )}

            {activePage === "VendorQuotationForComparison" && (
                <QuotationList handleBackWinderMachineEntry={handleBackWinderMachineEntry} formMode={0} />
            )}
        </Box>
    );
};
export default PurchaseManagement;